import styled from "styled-components";
import "./index.css";
import { returnColor } from "Pages/MyLibrary/MyLibraryTable";
import { convertDateTime } from "utilFunctions/helperFunctions/convertDateTime";
import EditIcon from "Assets/Icons/Editicon";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { useContext } from "react";
import { UserInfoContext } from "Context/CommonContext";
import { capitalizeFirstCharaterOfString } from "utilFunctions/helperFunctions/utilFunctions";
export const capitalizeFirstLetter = (word: string) => {
  if (!word) return "";
  return word.charAt(0).toUpperCase() + word.slice(1);
};
export const DivStyledStatus = styled<any>("div")`
  background-color: ${(props: any) => props.color};
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  display: flex;
  margin-left: auto;
  font-size: 12px;
  padding: 4px 11px;
  color: #ffffff;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  width: fit-content;
`;
const StudentCommentListingBox = ({
  comment,
  CommentEditToggle,
  lopActionList,
  lopReasonList,
}: any) => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const returnLopAction = (id: number) => {
    return lopActionList
      .filter((ele: any) => id === ele.value)
      .map((el: any) => el.label);
  };
  const returnLopReason = (arr: any[]) => {
    return lopReasonList
      .filter((ele: any) => arr.includes(ele.value))
      .map((el: any) => el.label);
  };
  const abbreviateName = (fullName: string) => {
    const nameParts = fullName.split(" ");

    if (nameParts.length >= 2) {
      const firstName = capitalizeFirstLetter(nameParts[0]);
      const middleName =
        nameParts.length > 2 ? capitalizeFirstLetter(nameParts[1]) : "";
      const lastName = capitalizeFirstLetter(nameParts[nameParts.length - 1]);

      const abbreviatedFirstName =
        firstName.charAt(0) + (middleName ? "." : "");

      return `${abbreviatedFirstName}.${lastName}`;
    }

    console.log("comment:---------", comment.name);
    return capitalizeFirstLetter(fullName);
  };
  return (
    <div className="mainCommentDiv">
      <div>
        <div className="profileCommentDiv">
          <span className="profileCommentDivName">
            {comment &&
              comment.name &&
              capitalizeFirstCharaterOfString(comment?.name)}
          </span>
        </div>
      </div>
      <div className="w-100">
        <div className="d-flex justify-content-between w-100">
          <div className="d-flex">
            <div className="nameDiv">
              {" "}
              {comment?.name && comment?.name != null
                ? abbreviateName(comment?.name)
                : "-"}
            </div>
            <div className="dateDiv">
              {convertDateTime(comment.updatedAt, "DD MMM, YY")}
            </div>
          </div>
          {userInfo && userInfo.id == comment.facId && (
            <EditIcon
              className="cursorHoverCSS p-1"
              onClick={() => {
                CommentEditToggle(comment);
              }}
            />
          )}
        </div>
        <div className="d-flex">
          <div className="followUpDiv">
            <span>
              {comment.type == "absentee"
                ? "Absentee"
                : comment.type == "ptm"
                ? "PTM"
                : "LOP"}
            </span>
            <span className="pl-1">
              {comment?.ptmMode && comment.ptmMode == "Zoom"
                ? "Online"
                : comment.ptmMode}
            </span>
          </div>
          <div>
            {comment.subj !== null && (
              <DivStyledStatus color={returnColor(comment.subj)}>
                {comment.subj}
              </DivStyledStatus>
            )}
          </div>
        </div>
        <div className="commentDiv">{comment.comment}</div>
        <div className="commentReasonDiv">
          {comment.lopReason != null && (
            <div>Reason: {returnLopReason(comment.lopReason).join(", ")}</div>
          )}
          {comment.lopAction != null && (
            <div>Action: {returnLopAction(comment.lopAction).toString()}</div>
          )}
          {comment.expectedReturnDate != null && (
            <div>
              <strong style={{ color: "#000" }}>
                Expected Return Date:{" "}
                {convertDateTime(comment.expectedReturnDate, "DD MMM, YY")}
              </strong>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default StudentCommentListingBox;
